// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module_container_kFw3g","row":"index-module_row_TWpav","icon-checked":"index-module_icon-checked_1ZRAT","icon-unchecked":"index-module_icon-unchecked_11tCR"};